<template>
  <v-calendar
    is-expanded
    :title-position="position"
    v-model="currentDate"
    color="orange"
    locale="vi-VN"
    :firstDayOfWeek="2"
    @update:from-page="pageChange"
    :attributes='attributes'
  >
    <template #day-popover="{ day, dayTitle, attributes }">
      <div>
        <div class="text-xs text-gray-300 font-semibold text-center">
          {{ day.ariaLabel }}
        </div>
        <p class="title text-center">Sinh nhật trong ngày</p>
        <div
          v-for="attr in attributes"
          :key="attr.key"
        >
          <div class="birthday-person__block">
            <p
              v-for="(item,index) in attr.customData"
              :key="index"
              class="birthday-person__item"
            >
              {{ item.name }} - {{ MethodService.formatDate(item.birthday, 'date') }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </v-calendar>
</template>
<script>
import EmployeeApi from '@/moduleApi/EmployeeApi'
import MethodService from '@/service/MethodService'
export default {
  components: {},
  props: {
    data : {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      MethodService,
      currentDate: new Date(),
      calendarMonth: new Date().getMonth(),
      calendarYear: new Date().getFullYear(),
      dataEvent: [],
      myFromPage: null,
      currentPage: null,
    }
  },
  methods: {
    pageChange (page) {
      this.calendarMonth = page.month
      this.calendarYear = page.year
      this.getEmployeeBirthday()
    },
    async getEmployeeBirthday() {
      try {
        const resApi = await EmployeeApi.GetListEmployeeHaveBirthdayInMonth({
          month: this.calendarMonth,
        })
        this.dataEvent = []
        resApi.result.employees.forEach((item) => {
          item.birthdaySameYear = new Date(new Date(item.birthday).setFullYear(this.calendarYear))
        })
        const groupDate = resApi.result.employees.reduce((group, item) => {
          const { birthdaySameYear } = item;
          group[birthdaySameYear] = group[birthdaySameYear] ? group[birthdaySameYear] : [];
          group[birthdaySameYear].push(item);
          return group;
        }, {});
        for (const [key, value] of Object.entries(groupDate)) {
          this.dataEvent.push({
            dates: new Date(key),
            customData: value,
            color: 'red',
          })
        }
      } catch (error) {
        console.log('error', error)
      }
    },
  },
  created() {
    // this.getEmployeeBirthday()
  },
  computed: {
    attributes() {
      return [
        // Attributes for todos
        ...this.dataEvent.map(data => ({
          id: data.id,
          dates: data.dates,
          dot: {
            color: data.color,
            class: 'dot',
          },
          popover: {
            label: data.customData,
            visibility: 'click',
            hideIndicator: true,
          },
          customData: data.customData,
        })),
      ];
    },
  },
}
</script>
<style lang="scss">
.vc-popover-content-wrapper {
  .vc-popover-content {
    background-color: var(--orange);
    border-color: var(--orange);
    width: 250px;
    div {
      &:first-child {
        max-width: 200px;
        div {
          &:first-child {
            font-family: 'Roboto', sans-serif;
          }
        }
      }
    }
    .title {
      font-size: 13px;
      font-weight: 500;
      color: #fff;
      margin: 2px 0;
      font-family: 'Roboto', sans-serif;
    }
    .vc-day-popover-row-content {

      .vc-day-popover-row {
        font-family: 'Roboto', sans-serif;
      }
      .birthday-person__block {
        display: flex;
        flex-direction: column;
        .birthday-person__item {
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          margin: 2px 0;
          font-family: 'Roboto', sans-serif;
          width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
  }
  .vc-popover-caret {
    display: none;
  }
}
</style>
